import { ChangeEvent, useState } from 'react'
import { PointCardGradeType } from 'types/pointCard'

const initialState: PointCardGradeType[] = [
  { name: '', threshold: 0 },
  { name: '', threshold: 200 },
  { name: '', threshold: 300 },
  { name: '', threshold: 1000 },
  { name: '', threshold: 3000 },
  { name: '', threshold: 6000 },
]

// 3~6段階のポイントカードのグレードを管理するカスタムフック
const usePointCardGrades = () => {
  const [grades, setGrades] = useState<PointCardGradeType[]>(initialState)

  const addGrade = () => {
    setGrades((prevState) => {
      if (prevState.length >= 6) return prevState
      const maxThreshold = Math.max(...prevState.map((grade) => grade.threshold))
      // 現段階の最大グレードの閾値に100を足した値を新しいグレードの閾値とする
      return [...prevState, { name: '', threshold: maxThreshold + 100 }]
    })
  }

  const deleteGrade = (index: number) => {
    setGrades((prevState) => {
      if (prevState.length <= 3) return prevState
      return prevState.filter((_, i) => i !== index)
    })
  }

  const handleGradeName = (index: number, e: ChangeEvent<HTMLInputElement>) => {
    setGrades((prevState) => {
      const newGrades = [...prevState]
      newGrades[index].name = e.target.value
      return newGrades
    })
  }

  const handleGradeThreshold = (index: number, value: string) => {
    if (!/^[0-9]*$/.test(value)) return
    const newGrades = [...grades]
    for (let i = index; i < newGrades.length; i++) {
      if (i === index) {
        // 選択されたグレードの閾値を更新
        newGrades[i].threshold = Number(value)
      } else if (i > index) {
        // 選択されたグレード以降のグレードの閾値を更新
        const prevThreshold = parseInt(newGrades[i - 1].threshold.toString())
        const minThreshold = prevThreshold + 100
        newGrades[i].threshold = Math.max(minThreshold, newGrades[i].threshold)
      }
    }
    setGrades(newGrades)
  }

  return { grades, addGrade, deleteGrade, handleGradeName, handleGradeThreshold, setGrades }
}

export default usePointCardGrades
